// extracted by mini-css-extract-plugin
export default {"wrapper":"CrudActions_wrapper_UZyQm","action":"CrudActions_action_gIjz8"};